import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const RetourProcessRoute: Route = {
  path: 'retour/process',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/process.component').then((m) => m.ProcessComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
